import {
  CountryCodes,
  CurrencyCodes,
  Industry,
  LanguageCodes,
  VoiceLlm,
  VoiceStyle,
} from "Infrastructure/Api/Api";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";

export const CzechResourcesDictionary: ResourceDictionary = {
  Common: {
    Admin: "Admin",
    AppName: "Vivelo.AI",
    ComingSoon: "Připravujeme",
    ComingSoonNote: "Obsah bude brzy aktualizován.",
    BackToSignIn: "Zpět na přihlášení",
    Years: "{{count}} let",
    Years_one: "{{count}} rok",
    Years_two: "{{count}} roky",
    Years_few: "{{count}} roky",
    Years_other: "{{count}} let",
    YearsLabel: "let",
    YearsLabel_one: "rok",
    YearsLabel_few: "roky",
    YearsLabel_other: "let",
    Month: "měsíc",
    Months: "{{count}} měsíců",
    Months_one: "{{count}} měsíc",
    Months_two: "{{count}} měsíce",
    Months_few: "{{count}} měsíce",
    Months_other: "{{count}} měsíců",
    Continue: "Pokračovat",
    Step: "KROK {{actual}} Z {{count}}",
    TextCopied: "Text byl zkopírován do schránky.",
    Yes: "Ano",
    No: "Ne",
    Choose: "Vyberte",
    Download: "Stáhnout",
    Upload: "Nahrát",
    Downloading: "Stahování",
    UnsupportedFileType: "Nepodporovaný typ souboru",
    Email: "E-mail",
    Password: "Heslo",
    ExampleLogin: "např. antonin.vomacka@email.cz",
    PiecesShort: "{{count, number}} ks",
    PiecesSuffix: "ks",
    Active: "Aktivní",
    Inactive: "Neaktivní",
    Assigned: "Přiřazený",
    Actual: "Aktuální",
    Blocked: "Blokováno",
    Canceled: "Zrušeno",
    Cancel: "Zrušit",
    Close: "Zavřít",
    Confirm: "Potvrdit",
    Open: "Otevřít",
    Ended: "Ukončeno",
    All: "Vše",
    AllStatuses: "Všechny stavy",
    PrivacyPolicyLink: "Zásadách zpracování osobních údajů.",
    Error:
      "Něco se pokazilo. Omlouváme se za komplikace. Zkuste to prosím znovu za chvíli.",
    Save: "Uložit",
    Search: "Hledat",
    Reset: "Reset",
    WithTax: "s DPH",
    WithoutTax: "bez DPH",
    Edit: "Upravit",
    Back: "Zpět",
    BackToProjects: "Zpět na projekty",
    BackToProject: "Zpět na projekt",
    BackToDashboard: "Zpět na Dashboard",
    BackToClients: "Zpět na klienty",
    BackToClient: "Zpět na klienta",
    BackToActors: "Zpět na herce",
    BackToPartners: "Zpět na partnery",
    BackToPartner: "Zpět na partnera",
    BackToModules: "Zpět na moduly",
    BackToModule: "Zpět na modul",
    BackToPriceCategories: "Zpět na cenové kategorie",
    Delete: "Smazat",
    PreviousStep: "Předchozí krok",
    SaveAndClose: "Uložit a zavřít",
    SaveSuccess: "Uložení proběhlo úspěšně.",
    CompanyNumber: "IČ",
    TaxNumber: "DIČ",
    PersonalNumber: "RČ",
    ProcessedByRepresentative: "Zpracoval{{gender}} {{name}}",
    SendByRepresentative: "Odeslal{{gender}} {{name}}",
    SignOut: "Odhlásit se",
    Language: "Jazyk",
    Users: "Uživatelé",
    NewProject: "Nový projekt",
    NewActor: "Nový herec",
    NewPartner: "Nový partner",
    NewModule: "Nový modul",
    NewClient: "Nový klient",
    Dashboard: "Dashboard",
    Projects: "Projekty",
    Actors: "Herci",
    Partners: "Partneři",
    Modules: "Moduly",
    PriceCategories: "Cenové kategorie",
    NewPriceCategory: "Nová cenová kategorie",
    Clients: "Klienti",
    MusicAudio: "Hudba a audio",
    Wallet: "Peněženka",
    Invoices: "Vyúčtování",
    WithdrawalApprovals: "Výplaty hercům",
    RegistrationRequests: "Žádosti o registraci",
    BackToWithdrawalApprovals: "Zpět na výplaty hercům",
    BackToRegistrationRequests: "Zpět na žádosti o registraci",
    ActivityLog: "Přehled aktivit",
    Reporting: "Reporting",
    GoodMorning: "Dobré ráno, {{name}}",
    StatusDone: "Hotovo",
    StatusClosed: "Uzavřeno",
    StatusInProgress: "Probíhá",
    StatusDraft: "Koncept",
    StatusWaitingForApproval: "Čeká na schválení",
    StatusRejectedByActor: "Zamítnuto hercem",
    StatusAwaitingFunds: "Čeká na prostředky",
    StatusActive: "Aktivní",
    StatusInactive: "Neaktivní",
    Status: "Stav",
    NoItems: "Žádné položky",
    Currency: "Měna",
    Currencies: {
      [CurrencyCodes.EUR]: "Euro (€)",
      [CurrencyCodes.USD]: "Americký dolar ($)",
      [CurrencyCodes.CZK]: "Česká koruna (Kč)",
      [CurrencyCodes.GBP]: "Britská libra (£)",
      [CurrencyCodes.PLN]: "Polský zlotý (zł)",
      [CurrencyCodes.CHF]: "Švýcarský frank (CHF)",
      [CurrencyCodes.SEK]: "Švédská koruna (kr)",
      [CurrencyCodes.NOK]: "Norská koruna (kr)",
      [CurrencyCodes.DKK]: "Dánská koruna (kr)",
      [CurrencyCodes.HUF]: "Maďarský forint (Ft)",
      [CurrencyCodes.RON]: "Rumunský leu (lei)",
    },
    Languages: {
      [LanguageCodes.Czech]: "Čeština",
      [LanguageCodes.English]: "Angličtina",
      [LanguageCodes.Deutsch]: "Němčina",
      [LanguageCodes.French]: "Francouzština",
      [LanguageCodes.Italian]: "Italština",
      [LanguageCodes.Spanish]: "Španělština",
      [LanguageCodes.Polish]: "Polština",
      [LanguageCodes.Dutch]: "Nizozemština",
      [LanguageCodes.Romanian]: "Rumunština",
      [LanguageCodes.Hungarian]: "Maďarština",
      [LanguageCodes.Portuguese]: "Portugalština",
      [LanguageCodes.Swedish]: "Švédština",
      [LanguageCodes.Bulgarian]: "Bulharština",
      [LanguageCodes.Danish]: "Dánština",
      [LanguageCodes.Finnish]: "Finština",
      [LanguageCodes.Slovak]: "Slovenština",
      [LanguageCodes.Croatian]: "Chorvatština",
      [LanguageCodes.Lithuanian]: "Litevština",
      [LanguageCodes.Slovenian]: "Slovinština",
      [LanguageCodes.Latvian]: "Lotyština",
      [LanguageCodes.Estonian]: "Estonština",
      [LanguageCodes.Greek]: "Řečtina",
      [LanguageCodes.Maltese]: "Maltština",
      [LanguageCodes.Irish]: "Irština",
    },
    Countries: {
      [CountryCodes.AT]: "Rakousko",
      [CountryCodes.BE]: "Belgie",
      [CountryCodes.BG]: "Bulharsko",
      [CountryCodes.CY]: "Kypr",
      [CountryCodes.CZ]: "Česko",
      [CountryCodes.DE]: "Německo",
      [CountryCodes.DK]: "Dánsko",
      [CountryCodes.EE]: "Estonsko",
      [CountryCodes.ES]: "Španělsko",
      [CountryCodes.FI]: "Finsko",
      [CountryCodes.FR]: "Francie",
      [CountryCodes.GR]: "Řecko",
      [CountryCodes.HR]: "Chorvatsko",
      [CountryCodes.HU]: "Maďarsko",
      [CountryCodes.IE]: "Irsko",
      [CountryCodes.IT]: "Itálie",
      [CountryCodes.LT]: "Litva",
      [CountryCodes.LU]: "Lucembursko",
      [CountryCodes.LV]: "Lotyšsko",
      [CountryCodes.MT]: "Malta",
      [CountryCodes.NL]: "Nizozemsko",
      [CountryCodes.PL]: "Polsko",
      [CountryCodes.PT]: "Portugalsko",
      [CountryCodes.RO]: "Rumunsko",
      [CountryCodes.SE]: "Švédsko",
      [CountryCodes.SI]: "Slovinsko",
      [CountryCodes.SK]: "Slovensko",
    },
    Industries: {
      [Industry.Retail]: "Maloobchod",
      [Industry.Finance]: "Finance",
      [Industry.Automotive]: "Automotive",
      [Industry.Ecommerce]: "E-commerce",
      [Industry.EnergyAndUtilities]: "Energetika & Utilities",
      [Industry.Pharmaceuticals]: "Farmaceutický průmysl",
      [Industry.Gaming]: "Hry",
      [Industry.LogisticsAndTransport]: "Logistika & Doprava",
      [Industry.MediaAndEntertainment]: "Média & Zábava",
      [Industry.FashionAndLifestyle]: "Móda & Lifestyle",
      [Industry.RealEstate]: "Nemovitosti",
      [Industry.NonProfit]: "Neziskový sektor",
      [Industry.HospitalityAndTourism]: "Pohostinství & Cestovní ruch",
      [Industry.Insurance]: "Pojišťovnictví",
      [Industry.FoodAndGastronomy]: "Potravinářství & Gastronomie",
      [Industry.LegalServices]: "Právní služby",
      [Industry.AdvertisingAndMarketing]: "Reklama & Marketing",
      [Industry.SportsAndFitness]: "Sport & Fitness",
      [Industry.TechnologyAndIT]: "Technologie & IT",
      [Industry.Telecommunications]: "Telekomunikace",
      [Industry.PublicSector]: "Veřejný sektor & Stát",
      [Industry.Education]: "Vzdělávání",
      [Industry.Healthcare]: "Zdravotnictví",
      [Industry.Other]: "Ostatní",
    },
    VoiceLlms: {
      [VoiceLlm.ElevenLabs_V3]: "ElevenLabs V3",
      [VoiceLlm.ElevenLabs_V2]: "ElevenLabs V2",
      [VoiceLlm.MicrosoftTts]: "Microsoft TTS",
      [VoiceLlm.AiVoice]: "AIVoice",
    },
    VoiceStyles: {
      [VoiceStyle.Neutral]: "Neutrální",
      [VoiceStyle.Cheerful]: "Veselý",
      [VoiceStyle.Excited]: "Nadšený",
      [VoiceStyle.Friendly]: "Přátelský",
      [VoiceStyle.Sad]: "Smutný",
      [VoiceStyle.Angry]: "Naštvaný",
      [VoiceStyle.Calm]: "Klidný",
      [VoiceStyle.Newscast]: "Zpravodajský",
      [VoiceStyle.Whispering]: "Šeptající",
      [VoiceStyle.Authoritative]: "Autoritativní",
      [VoiceStyle.Empathetic]: "Empatický",
    },
  },
  JobDetail: {
    SelectLanguageModelPlaceholder: "Vyberte jazykový model",
    InstructionsPlaceholder: "Vložte instrukce pro generování textu...",
    PrepareYourVoicelines: "Scénář hlasového spotu",
    GeneratePreview: "Vygenerovat ukázku",
    GenerateFullVoiceover: "Vygenerovat celý spot",
    VoicelinesMustBeFilledFirst: "Text musí být nejdříve vyplněn",
    FailedToGeneratePreview: "Nepodařilo se vygenerovat ukázku",
    FailedToGenerateClip: "Nepodařilo se vygenerovat spot",
    GeneralSettingsTab: "Obecná nastavení",
    ParametersTab: "Parametry",
    FinalizeTab: "Generované výstupy",
    SegmentSettingsTab: "Nastavení segmentu",
    BackgroundMusic: "Hudba na pozadí",
    NoMusic: "Bez hudby",
    SelectBackgroundMusic: "Vyberte hudbu na pozadí",
    SelectFinalClip: "Vyberte finální klip",
    AlreadyFinalized: "Tento job byl již finalizován.",
    FinalClipReady: "Finální klip je připraven.",
    DownloadFinalClip: "Stáhnout finální klip",
    Clip: "Spot",
    ClipPreview: "Ukázka",
    FinalizeConfirm: "Finalizovat",
    FinalizeSuccess: "Job byl úspěšně finalizován",
    FinalizeError: "Nepodařilo se finalizovat job",
    FinalizeInsufficientBalance:
      "Na účtu není dostatek kreditu pro zaplacení tohoto jobu",
    DefaultVoiceModel: "Výchozí hlasový model",
    GlobalLanguage: "Globální jazyk",
    Language: "Jazyk",
    GlobalSpeed: "Globální rychlost",
    GlobalVolume: "Globální hlasitost",
    CostLimit: "Limit nákladů",
    Variables: "Proměnné",
    AddVariable: "Přidat proměnnou",
    // Script editor
    SegmentText: "Text",
    VoiceSegmentHeading: "Hlas",
    PauseSegmentHeading: "Pauza",
    AddVoiceSegment: "Přidat hlas",
    AddPause: "Přidat pauzu",
    AddBackgroundAudio: "Přidat média",
    DeleteSegment: "Smazat segment",
    NoSegmentSelected: "Vyberte segment v editoru",
    SelectVoiceModel: "Vyberte hlasový model",
    Emotion: "Emoce",
    EmotionAndReactions: "Emoce a reakce",
    SpeedFactor: "Rychlost",
    VolumePercent: "Hlasitost",
    PauseDuration: "Délka pauzy",
    Seconds: "s",
    VariableName: "Název proměnné",
    VariableDefaultValue: "Výchozí hodnota",
    AddVariableDialogTitle: "Přidat proměnnou",
    AddVariableDialogConfirm: "Přidat",
    DeleteVariable: "Smazat proměnnou",
    ScriptErrors: "Script obsahuje {{count}} chyb, opravte je před uložením.",
    SegmentEmptyText: "Segment neobsahuje žádný text",
    SegmentNoActor: "Vyberte herce pro tento segment",
    SegmentNoFile: "Vyberte soubor pro tento segment",
    SegmentZeroDuration: "Délka pauzy musí být větší než 0",
    SegmentInvalidStartTime: "Čas začátku musí být kladné číslo",
    SegmentInvalidSpeedFactor: "Rychlost musí být mezi 0,5× a 2,0×",
    EmptyScript: "Skript neobsahuje žádné segmenty",
    SaveScript: "Uložit",
    SaveScriptSuccess: "Skript byl úspěšně uložen",
    SaveScriptError: "Nepodařilo se uložit skript",
    ExpectedPrice: "Předpokládaná cena",
    ExpectedLength: "Odhadovaná délka",
    SelectActorFirst: "Nejdříve vyberte herce",
    AddSegmentTooltip: "Přidat segment",
    RemoveEmotion: "Bez emoce",
    // AI integration
    AiRefinementTitle: "Úpravy pomocí AI",
    AiTab: "AI",
    AiDraftTitle: "AI návrh textu",
    AiDraftDescription:
      "Zadejte instrukce a AI vygeneruje návrh textu pro voiceover. Text můžete dále upravovat a poté převést na skript.",
    ConvertToScript: "Převést na skript",
    ConvertToVoiceSegments: "Převést na hlasové segmenty",
    CopyToClipboard: "Kopírovat do schránky",
    SkipToManualEdit: "Přeskočit, psát ručně",
    BackToQuestionnaire: "Zpět k otázkám",
    RegenerateFromQuestionnaire: "Vygenerovat znovu",
    BackToAiDraft: "Zpět k AI návrhu a otázkám",
    WorkingArtifact: "Pracovní artefakt",
    AiDraftEmptyState:
      "Zadejte instrukce a AI vám pomůže sestavit první verzi textu.",
    AiArtifactEmptyState:
      "Zadejte instrukce pro úpravu scénáře. Návrhy od AI se zobrazí zde a můžete je jedním kliknutím vložit do scénáře.",
    AddToScript: "Přidat do skriptu",
    JobNotFound: "Job nebyl nalezena",
    AudioFormat: "Formát audia",
    SampleRate: "Vzorkovací frekvence",
    Bitrate: "Přenosová rychlost",
    AudioChannels: "Kanály",
    ScriptEditorEmptyState: "Přidejte první segment pomocí tlačítek výše",
    DeletePause: "Smazat pauzu",
    DeleteMedia: "Smazat médium",
    JobReadOnlyBanner: "Tento job je uzamčen a nelze ho upravovat.",
    AddVariableTooltip: "Vloží proměnnou na pozici kurzoru / ohraničí výběr",
    DefaultVariableName: "nova_promenna",
    MediaStartAt: "Začátek přehrávání",
    MediaDuration: "Délka přehrávání",
    ClipPrice: "Cena klipu",
    AwaitingFundsMessage:
      "Všichni herci schválili, ale na účtu není dostatek kreditu pro finalizaci. Dobijte kredit a zkuste to znovu.",
    RetryFinalization: "Opakovat finalizaci",
    RetryFinalizationSuccess: "Job byl úspěšně finalizován",
    RetryFinalizationError: "Nepodařilo se finalizovat job",
    Activate: "Aktivovat",
    Deactivate: "Deaktivovat",
    ActivateSuccess: "Job byl úspěšně aktivován",
    DeactivateSuccess: "Job byl úspěšně deaktivován",
    StatusChangeError: "Nepodařilo se změnit stav jobu",
    AddReaction: "Přidat reakci",
    AddReactionTooltip:
      "Vložit reakci (smích, šepot, …) na pozici kurzoru. K dispozici jen pro ElevenLabs v3.",
    ReactionOnlyV3Hint:
      "Reakce jsou podporovány pouze hlasy ElevenLabs v3; u ostatních modelů budou ignorovány.",
    Reaction: {
      Heading: "Reakce",
      CategoryReactions: "Reakce",
      CategoryVolumeEnergy: "Hlasitost a energie",
      CategoryPacing: "Tempo a rytmus",
      Custom: "Vlastní",
      CustomPlaceholder: "např. angry english accent",
      RemoveReaction: "Odstranit reakci",
      EditReaction: "Upravit reakci",
      Values: {
        Gasp: "Zalapání po dechu",
        Sigh: "Povzdech",
        Laughs: "Smích",
        Gulps: "Polknutí",
        Crying: "Pláč",
        EvilLaugh: "Zlý smích",
        Hums: "Broukání",
        Giggle: "Chichotání",
        Whispering: "Šeptání",
        Shouting: "Křik",
        Quietly: "Tiše",
        Loudly: "Hlasitě",
        Sings: "Zpívání",
        Sarcastic: "Sarkasticky",
        Stammers: "Koktání",
        Rushed: "Ve spěchu",
      },
    },
    Wizard: {
      StepQuestionnaire: "Otázky",
      StepAiDraft: "AI Návrh",
      StepScriptEditor: "Editor skriptu",
    },
    ChoiceScreen: {
      Title: "Jak chcete začít?",
      Description:
        "Vyberte způsob, jakým chcete vytvořit podklad pro voiceover.",
      AnswerQuestionsTitle: "Odpovědět na otázky",
      AnswerQuestionsDescription:
        "Zodpovězte předpřipravené otázky a text se vygeneruje automaticky na základě vašich odpovědí.",
      OwnPromptTitle: "Zadat vlastní instrukce",
      OwnPromptDescription:
        "Přeskočte otázky a zadejte vlastní pokyny pro AI přímo.",
    },
    Questionnaire: {
      Title: "Odpovězte na otázky",
      Description:
        "Zodpovězte následující otázky. Na základě odpovědí bude vygenerován návrh textu.",
      Generate: "Vygenerovat návrh",
      Continue: "Pokračovat",
      Skip: "Přeskočit",
      EditAnswers: "Upravit odpovědi",
      OtherOption: "Jiné",
      AnswersSaved: "Odpovědi byly uloženy.",
      Back: "Zpět",
      GeneratingDraft: "Generuji návrh textu...",
    },
  },
  Dashboard: {
    CreateNewProject: "Vytvořit nový projekt",
    RecentProjects: "Nedávné projekty",
    SingleActorVoiceMax60s: "Jeden herec - max. 60 sekund",
    ProjectName: "Název projektu",
    Client: "Klient",
    License: "Licence",
    Jobs: "Jobs",
    Budget: "Rozpočet",
    Expense: "Výdaje",
    Status: "Stav",
    SearchProjects: "Hledat projekty",
    SearchProjectsPlaceholder: "Název projektu, klient...",
    AllClients: "Všichni klienti",
    AllStatuses: "Všechny stavy",
    Active: "Aktivní",
    Completed: "Dokončeno",
    Pending: "Čeká",
    ReportingOverview: "Přehled reportingu",
    ViewFullReport: "Zobrazit celý report",
    PendingWithdrawals: "Čekající výplaty hercům",
    NoPendingWithdrawals: "Žádné čekající výplaty k schválení.",
    ViewAllWithdrawals: "Zobrazit všechny výplaty",
  },
  ActivityLog: {
    Title: "Přehled aktivit",
    Timestamp: "Čas",
    User: "Uživatel",
    Event: "Událost",
    Note: "Poznámka",
    Detail: "Detail",
    AllEventTypes: "Všechny události",
    DateFrom: "Datum od",
    DateTo: "Datum do",
    NoActivities: "Žádné aktivity k zobrazení",
    ActorCreated: "Vytvoření herce",
    ActorPriceCategoryChanged: "Změna sazby herce",
    PartnerCreated: "Vytvoření partnera",
    ProjectCreated: "Vytvoření projektu",
    ProjectCompleted: "Dokončení projektu",
    ProjectClosed: "Uzavření projektu",
    JobCompleted: "Dokončení jobu",
    PartnerCreditTopUp: "Dobití kreditů partnera",
    ActorPayoutApproved: "Vyplacení provize herci",
    ClientCreated: "Vytvoření klienta",
  },
  Projects: {
    DefaultLanguageOption: "Výchozí (jazyk herce)",
    CreateProjectModal: {
      Title: "Vytvořit nový projekt",
      SelectModule: "Vyberte modul",
      SelectModulePlaceholder: "Vyberte modul",
      Client: "Klient",
      SelectClientPlaceholder: "Vyberte klienta",
      Name: "Název",
      NamePlaceholder: "Zadejte název projektu",
      Industry: "Odvětví",
      SelectIndustryPlaceholder: "Vyberte odvětví",
      Language: "Jazyk",
      SelectLanguagePlaceholder: "Vyberte jazyk",
      LicensedCountries: "Licencované země",
      SelectLicensedCountriesPlaceholder: "Vyberte licencované země",
      JobsLimit: "Limit zakázek",
      JobsLimitPlaceholder: "Zadejte maximální počet zakázek",
      AmountLimit: "Limit částky",
      AmountLimitPlaceholder: "Zadejte maximální částku",
      StartDate: "Datum zahájení",
      EndDate: "Datum ukončení",
      ProjectState: "Stav projektu",
      ProjectStatePlaceholder: "Vyberte stav projektu",
      Create: "Vytvořit",
      SuccessMessage: "Projekt byl úspěšně vytvořen",
      ErrorMessage: "Nepodařilo se vytvořit projekt",
      HasExclusiveContracts: "Mám exkluzivní smlouvu s hercem/herci",
      ContractedActor: "Smluvní herec",
      ContractPrice: "Cena smlouvy",
      ContractJobsLimit: "Limit zakázek smlouvy",
      AddExclusiveContract: "Přidat další exkluzivní smlouvu",
    },
    EditProjectModal: {
      Title: "Upravit projekt",
      Edit: "Uložit",
      SuccessMessage: "Projekt byl úspěšně aktualizován",
      ErrorMessage: "Nepodařilo se aktualizovat projekt",
    },
    CreateJobModal: {
      Title: "Vytvořit nový job",
      Name: "Název",
      NamePlaceholder: "Zadejte název jobu",
      Create: "Vytvořit",
      SuccessMessage: "Job byl úspěšně vytvořen",
      ErrorMessage: "Nepodařilo se vytvořit job",
    },
    ProjectActorsModal: {
      Title: "Přidat herce do projektu",
      Approve: "Schválit",
      SuccessMessage: "Seznam herců úspěšně aktualizován",
      ErrorMessage: "Nepodařilo se aktualizovat seznam herců",
      CannotRemoveActorWithActiveJobs:
        "Herce nelze odebrat, protože má dokončené nebo čekající joby.",
    },
    ProjectDetail: {
      Information: "Informace",
      EditInformation: "Upravit informace",
      Industry: "Odvětví",
      Client: "Klient",
      Language: "Jazyk",
      LicenceForStates: "Licence pro státy",
      JobsLimit: "Limit zakázek",
      CurrentJobs: "Aktuální jobs",
      StartDate: "Datum zahájení",
      EndDate: "Datum ukončení",
      Jobs: "Jobs",
      AddJobToProject: "Nový Job",
      JobsLimitExceeded: "Limit zakázek byl vyčerpán",
      JobLocked: "Job je uzamčený",
      Actors: "Herci",
      Actor: "Herec",
      AddActorToProject: "Přidat herce do projektu",
      CloseProject: "Ukončit projekt",
      FinishProject: "Dokončit projekt",
      CloseProjectConfirmTitle: "Ukončit projekt",
      CloseProjectConfirmContent:
        "Opravdu chcete projekt ukončit? Tuto akci nelze vrátit.",
      FinishProjectConfirmTitle: "Dokončit projekt",
      FinishProjectConfirmContent:
        "Opravdu chcete projekt označit jako dokončený? Tuto akci nelze vrátit.",
      DocumentsAndInvoices: "Dokumenty a faktury",
      NoDocumentsYet: "Zatím zde nejsou žádné dokumenty",
      ProjectNotFound: "Projekt nebyl nalezen",
      ProjectAmendment: "Dodatek projektu",
      CannotChangeActorBlocked: "Nelze změnit herce — existují dokončené joby",
      ExclusiveContract: "Exkluzivní smlouva",
    },
  },
  Actors: {
    Name: "Jméno",
    ActorName: "Jméno herce",
    NativeLanguage: "Rodný jazyk",
    Age: "Věk",
    Sex: "Pohlaví",
    PricePerModule: "Cena/Modul",
    AllLanguages: "Všechny jazyky",
    AllAges: "Všechny věky",
    AllSexes: "Všechna pohlaví",
    AllPrices: "Všechny ceny",
    Male: "Muž",
    Female: "Žena",
    CreateActorModal: {
      Title: "Nový herec",
      FirstName: "Jméno",
      FirstNamePlaceholder: "Zadejte jméno",
      LastName: "Příjmení",
      LastNamePlaceholder: "Zadejte příjmení",
      Email: "E-mail",
      EmailPlaceholder: "Zadejte e-mail",
      Phone: "Telefon",
      PhonePlaceholder: "Zadejte telefonní číslo",
      DateOfBirth: "Datum narození",
      Gender: "Pohlaví",
      GenderPlaceholder: "Vyberte pohlaví",
      Language: "Rodný jazyk",
      LanguagePlaceholder: "Vyberte jazyk",
      Industry: "Odvětví",
      IndustryPlaceholder: "Vyberte odvětví",
      Address: "Adresa",
      AddressPlaceholder: "Zadejte adresu",
      City: "Město",
      CityPlaceholder: "Zadejte město",
      PostalCode: "PSČ",
      PostalCodePlaceholder: "Zadejte PSČ",
      Country: "Stát",
      CountryPlaceholder: "Vyberte stát",
      IBAN: "IBAN",
      IBANPlaceholder: "Zadejte IBAN",
      SWIFT: "SWIFT/BIC",
      SWIFTPlaceholder: "Zadejte SWIFT/BIC",
      Invoicing: "Fakturační údaje (OSVČ, firma, agentura)",
      BusinessName: "Název firmy",
      BusinessNamePlaceholder: "Zadejte název firmy",
      CompanyNumber: "IČO",
      CompanyNumberPlaceholder: "Zadejte IČO",
      TaxNumber: "DIČ",
      TaxNumberPlaceholder: "Zadejte DIČ",
      BillingAddress: "Adresa",
      BillingAddressPlaceholder: "Zadejte fakturační adresu",
      BillingCity: "Město",
      BillingCityPlaceholder: "Zadejte město",
      BillingPostalCode: "PSČ",
      BillingPostalCodePlaceholder: "Zadejte PSČ",
      BillingCountry: "Stát",
      BillingCountryPlaceholder: "Vyberte stát",
      BillingIBAN: "IBAN",
      BillingIBANPlaceholder: "Zadejte IBAN",
      BillingSWIFT: "SWIFT/BIC",
      BillingSWIFTPlaceholder: "Zadejte SWIFT/BIC",
      Create: "Vytvořit",
      SuccessMessage: "Herec byl úspěšně vytvořen",
      ErrorMessage: "Nepodařilo se vytvořit herce",
    },
    EditActorModal: {
      Title: "Upravit herce",
      Save: "Uložit",
      SuccessMessage: "Herec byl úspěšně aktualizován",
      ErrorMessage: "Nepodařilo se aktualizovat herce",
    },
    ProfilePicture: {
      UploadPhoto: "Nahrát profilový obrázek",
      ChangePhoto: "Změnit profilový obrázek",
      DeletePhoto: "Smazat foto",
      CropTitle: "Upravit profilový obrázek",
      Zoom: "Přiblížení",
      UploadError: "Nepodařilo se nahrát profilový obrázek",
      DeleteError: "Nepodařilo se smazat profilový obrázek",
    },
    ActorDetail: {
      Information: "Informace",
      EditInformation: "Upravit informace",
      Email: "E-mail",
      Phone: "Telefon",
      DateOfBirth: "Datum narození",
      Gender: "Pohlaví",
      NativeLanguage: "Rodný jazyk",
      Industry: "Odvětví",
      Address: "Adresa",
      City: "Město",
      PostalCode: "PSČ",
      State: "Stát",
      IBAN: "IBAN",
      SWIFT: "SWIFT/BIC",
      BusinessName: "Název firmy",
      CompanyNumber: "IČO",
      TaxNumber: "DIČ",
      BusinessAddress: "Fakturační adresa",
      BillingIBAN: "IBAN (fakturační)",
      BillingSWIFT: "SWIFT/BIC (fakturační)",
      BackToActors: "Zpět na herce",
      NotFound: "Herec nebyl nalezen",
      Activate: "Aktivovat",
      Deactivate: "Deaktivovat",
      ActivateSuccess: "Herec byl úspěšně aktivován",
      DeactivateSuccess: "Herec byl úspěšně deaktivován",
      StatusChangeError: "Nepodařilo se změnit stav herce",
      VoiceActivateSuccess: "Hlas byl úspěšně aktivován",
      VoiceDeactivateSuccess: "Hlas byl úspěšně deaktivován",
      Voices: "Hlasy",
      Videos: "Videa",
      Transactions: "Transakce",
      TrainedVoices: "Natrénované hlasy",
      NewVoice: "Nový hlas",
      VoiceModuleRates: "Sazby hlasových modulů",
      UpdateRates: "Upravit sazby",
      NoRatesConfigured: "Žádné sazby nebyly nastaveny",
      ContractsAndAmendments: "Smlouvy a dodatky",
      NewAmendment: "Nový dodatek",
      ProjectAmendments: "Dodatky projektů",
      PriceCategories: {
        PricingModel: "Cenový model",
        ActorsCut: "Odměna herce",
        DefaultPriceTooltip: "Výchozí cena",
        Commission: "Provize",
        FinalPrice: "Finální cena",
        Notes: "Poznámky",
        State: "Stav",
        Approval: "Schválení",
        NotSet: "-",
        SaveAmendment: {
          SuccessMessage: "Sazby byly úspěšně uloženy",
          ErrorMessage: "Nepodařilo se uložit sazby",
        },
      },
      NoTrainedVoices: "Zatím žádné natrénované hlasy",
      Trained: "Natrénováno",
      VoiceName: "Název hlasu",
      Tags: "Štítky",
      VoiceTraining: "Trénink hlasu",
      TrainingModel: "Model tréninku",
      TrainingType: "Typ tréninku",
      ExternalVoiceID: "ID externího hlasu",
      ModelID: "ID modelu",
      UploadTrainingData: "Nahrát tréninková data",
      Files: "souborů",
      RemoveAllFiles: "Odstranit všechny soubory",
      SearchExternalVoice: "Hledat externí hlas",
      ContinueToEditAndPreview: "Pokračovat k editaci a náhledu",
      UploadFilesRequired:
        "Pro pokračování je nutné nahrát alespoň jeden tréninkový soubor",
      DemoPreview: "Demo preview",
      Speed: "Rychlost",
      Volume: "Hlasitost",
      GeneratePreview: "Vygenerovat ukázku",
      StartTraining: "Zahájit trénink",
      VoiceStatus: {
        Draft: "Koncept",
        UploadingTrainingFiles: "Nahrávání souborů",
        TrainingInProcess: "Trénink probíhá",
        TrainingCompleted: "Trénink dokončen",
        TrainingFailed: "Trénink selhal",
        TrainingVerificationRequired: "Vyžaduje ověření",
        Active: "Aktivní",
        Inactive: "Neaktivní",
      },
      VoiceTrainingTypes: {
        ElevenLabs_Instant: "ElevenLabs Instant",
        ElevenLabs_Professional: "ElevenLabs Professional",
      },
      NewVoiceModal: {
        Title: "Nový hlas",
        Create: "Vytvořit",
        SuccessMessage: "Hlas byl úspěšně vytvořen",
        ErrorMessage: "Nepodařilo se vytvořit hlas",
      },
      EditVoiceModal: {
        Title: "Upravit hlas",
        Save: "Uložit",
        SuccessMessage: "Hlas byl úspěšně aktualizován",
        ErrorMessage: "Nepodařilo se aktualizovat hlas",
      },
      GeneratePreviewError: {
        General: "Nepodařilo se vygenerovat náhled",
        WrongStatus: "Hlas musí být nejdříve natrénován",
      },
      OpenToCollaboration: "Otevřen spolupráci",
      NotOpenToCollaboration: "Nezájem o spolupráci",
    },
    ActorPriceCategoryStatus: {
      Allowed: "Povoleno",
      NotAllowed: "Zakázáno",
      Exclusive: "Exkluzivní",
    },
    ActorPriceCategoryApprovalType: {
      Automatic: "Automaticky",
      Manual: "Manuálně",
    },
  },
  Partners: {
    PartnerName: "Název partnera",
    Projects: "Projekty",
    Email: "E-mail",
    Phone: "Telefon",
    SearchPartnersPlaceholder: "Název partnera",
    AddSubPartnerButton: "Přidat podpartnera",
    CreatePartnerModal: {
      Title: "Vytvořit nového partnera",
      BusinessName: "Název firmy",
      BusinessNamePlaceholder: "Zadejte název firmy",
      SuperiorPartner: "Nadřazený partner",
      SuperiorPartnerPlaceholder: "Vyberte nadřazeného partnera",
      IdentificationNumber: "IČO",
      IdentificationNumberPlaceholder: "Zadejte IČO",
      VAT: "DIČ",
      VATPlaceholder: "Zadejte DIČ",
      Email: "E-mail",
      EmailPlaceholder: "Zadejte e-mail",
      Phone: "Telefon",
      PhonePlaceholder: "Zadejte telefonní číslo",
      Address: "Adresa",
      AddressPlaceholder: "Zadejte adresu",
      City: "Město",
      CityPlaceholder: "Zadejte město",
      PostalCode: "PSČ",
      PostalCodePlaceholder: "Zadejte PSČ (např. 123 45)",
      Country: "Země",
      CountryPlaceholder: "Vyberte zemi",
      Create: "Vytvořit",
      AllowRetroactivePayment: "Povolit partnerovi zpětné uhrazení faktury",
      SuccessMessage: "Partner byl úspěšně vytvořen",
      ErrorMessage: "Nepodařilo se vytvořit partnera",
    },
    PartnerDetail: {
      Information: "Informace",
      EditInformation: "Upravit informace",
      CompanyNumber: "IČO",
      TaxNumber: "DIČ",
      Email: "E-mail",
      Phone: "Telefon",
      Address: "Adresa",
      City: "Město",
      PostalCode: "PSČ",
      State: "Stát",
      Projects: "Projekty",
      NoProjects: "Žádné projekty",
      Contracts: "Smlouvy",
      NoContracts: "Žádné smlouvy",
      ParentPartner: "Nadřazený partner",
      BackToPartners: "Zpět na partnery",
      AvailableModules: "Dostupné moduly",
      NoModules: "Žádné moduly",
      EditAvailableModules: "Upravit dostupné moduly",
      Clients: "Klienti",
      NoClients: "Žádní klienti",
      Activate: "Aktivovat",
      Deactivate: "Deaktivovat",
      ActivateSuccess: "Partner byl úspěšně aktivován",
      DeactivateSuccess: "Partner byl úspěšně deaktivován",
      StatusChangeError: "Nepodařilo se změnit stav partnera",
    },
    EditAvailableModulesModal: {
      Title: "Upravit dostupné moduly",
      SearchPlaceholder: "Hledat modul",
      ModuleName: "Název modulu",
      BaseModule: "Základní modul",
      Save: "Uložit",
      SuccessMessage: "Dostupné moduly byly úspěšně aktualizovány",
      ErrorMessage: "Nepodařilo se aktualizovat dostupné moduly",
    },
    EditPartnerModal: {
      Title: "Upravit partnera",
      Save: "Uložit",
      SuccessMessage: "Partner byl úspěšně aktualizován",
      ErrorMessage: "Nepodařilo se aktualizovat partnera",
    },
  },
  Modules: {
    ModuleBase: "Typ modulu",
    ModuleName: "Název modulu",
    Projects: "Projekty",
    LastUpdated: "Poslední aktualizace",
    Availability: "Dostupnost",
    SearchModulesPlaceholder: "Název modulu",
    AvailabilityActive: "Aktivní",
    AvailabilityInactive: "Neaktivní",
    CreateModuleModal: {
      Title: "Vytvořit nový modul",
      Name: "Název",
      NamePlaceholder: "Zadejte název modulu",
      Type: "Typ modulu",
      TypePlaceholder: "Vyberte typ modulu",
      PriceCategory: "Cenový model",
      PriceCategoryPlaceholder: "Vyberte cenový model",
      CustomPrompt: "Vlastní prompt",
      CustomPromptPlaceholder: "Zadejte vlastní prompt pro modul",
      TextLlmsSection: "Konfigurace textových modelů:",
      VoiceLlmsSection: "Konfigurace hlasových modelů:",
      Create: "Vytvořit",
      SuccessMessage: "Modul byl úspěšně vytvořen",
      ErrorMessage: "Nepodařilo se vytvořit modul",
    },
    ModuleTypes: {
      SingleVoiceSpot: "Jednohlasý spot",
      MultiVoiceSpot: "Vícehlasý spot",
    },
    TextLlms: {
      OpenAI_ChatGpt5: "OpenAI ChatGPT 5",
    },
    VoiceLlms: {
      ElevenLabs_V3: "ElevenLabs V3",
      ElevenLabs_V2: "ElevenLabs V2",
      MicrosoftTts: "Microsoft TTS",
    },
    ModuleDetail: {
      BackToModules: "Zpět na moduly",
      Information: "Informace o modulu",
      EditInformation: "Upravit informace",
      ModuleName: "Název modulu",
      ModuleType: "Typ modulu",
      Status: "Stav",
      PriceCategory: "Cenový model",
      TextModels: "Textové modely",
      VoiceModels: "Hlasové modely",
      CustomPromptSection: "Vlastní prompt",
      NotFound: "Modul nebyl nalezen",
      Activate: "Aktivovat",
      Deactivate: "Deaktivovat",
      ActivateSuccess: "Modul byl úspěšně aktivován",
      DeactivateSuccess: "Modul byl úspěšně deaktivován",
      StatusChangeError: "Nepodařilo se změnit stav modulu",
      AvailablePartners: "Dostupný pro",
      NoPartners: "Žádní partneři",
      EditAvailablePartners: "Upravit partnery",
    },
    EditModuleModal: {
      Title: "Upravit modul",
      Save: "Uložit",
      SuccessMessage: "Modul byl úspěšně aktualizován",
      ErrorMessage: "Nepodařilo se aktualizovat modul",
    },
    EditAvailablePartnersModal: {
      Title: "Dostupní partneři",
      SearchPlaceholder: "Hledat partnery...",
      PartnerName: "Partner",
      Save: "Uložit",
      SuccessMessage: "Partneři byli úspěšně uloženi",
      ErrorMessage: "Nepodařilo se uložit partnery",
    },
    Questions: {
      Title: "Otázky modulu",
      EditQuestions: "Upravit otázky",
      NoQuestions: "Žádné otázky nejsou nakonfigurovány",
      AddQuestion: "Přidat otázku",
      RemoveQuestion: "Odebrat otázku",
      QuestionText: "Text otázky",
      QuestionTextPlaceholder: "Zadejte text otázky...",
      QuestionType: "Typ otázky",
      Required: "Povinná",
      Options: "Možnosti",
      AddOption: "Přidat možnost",
      RemoveOption: "Odebrat možnost",
      OptionTextPlaceholder: "Text možnosti...",
      SaveSuccess: "Otázky modulu byly úspěšně uloženy.",
      OtherOptionLabel: "Jiné (textová odpověď)",
      ValidationQuestionTextRequired: "Zadejte text otázky.",
      ValidationOptionTextRequired: "Zadejte text možnosti.",
      ValidationOptionsRequired: "Přidejte alespoň jednu možnost.",
      Types: {
        Text: "Textová odpověď",
        SingleChoice: "Jedna volba",
        MultiChoice: "Více voleb",
        SingleChoiceWithOther: "Jedna volba + Jiné",
        MultiChoiceWithOther: "Více voleb + Jiné",
      },
    },
  },
  PriceCategories: {
    Name: "Název",
    Type: "Typ",
    CommissionRate: "Provize",
    DefaultPrice: "Výchozí cena",
    DateCreated: "Datum vytvoření",
    DateUpdated: "Datum aktualizace",
    SearchPlaceholder: "Název cenové kategorie",
    PriceCategoryTypes: {
      PerMinute: "Za minutu",
      PerJob: "Za job",
    },
    PriceSuffix: {
      PerMinute: "€/min",
      PerJob: "€/job",
      PerProject: "€/projekt",
    },
    CreateModal: {
      Title: "Vytvořit novou cenovou kategorii",
      Name: "Název",
      NamePlaceholder: "Zadejte název cenové kategorie",
      TypePlaceholder: "Vyberte typ cenové kategorie",
      Create: "Vytvořit",
      SuccessMessage: "Cenová kategorie byla úspěšně vytvořena",
      ErrorMessage: "Nepodařilo se vytvořit cenovou kategorii",
    },
    Detail: {
      BackToList: "Zpět na cenové kategorie",
      Information: "Informace",
      EditInformation: "Upravit informace",
      NotFound: "Cenová kategorie nebyla nalezena",
      Activate: "Aktivovat",
      Deactivate: "Deaktivovat",
      ActivateSuccess: "Cenová kategorie byla úspěšně aktivována",
      DeactivateSuccess: "Cenová kategorie byla úspěšně deaktivována",
      StatusChangeError: "Nepodařilo se změnit stav cenové kategorie",
    },
    EditModal: {
      Title: "Upravit cenovou kategorii",
      Save: "Uložit",
      SuccessMessage: "Cenová kategorie byla úspěšně aktualizována",
      ErrorMessage: "Nepodařilo se aktualizovat cenovou kategorii",
    },
  },
  Clients: {
    CompanyName: "Název společnosti",
    Partner: "Partner",
    AllPartners: "Všichni partneři",
    Email: "E-mail",
    Phone: "Telefon",
    ProjectCount: "Počet projektů",
    SearchClientsPlaceholder: "Název klienta, partner...",
    CreateClientModal: {
      Title: "Vytvořit nového klienta",
      CompanyName: "Název společnosti",
      CompanyNamePlaceholder: "Zadejte název společnosti",
      CompanyNumber: "IČO",
      CompanyNumberPlaceholder: "Zadejte IČO",
      TaxNumber: "DIČ",
      TaxNumberPlaceholder: "Zadejte DIČ",
      Email: "E-mail",
      EmailPlaceholder: "Zadejte e-mail",
      Phone: "Telefon",
      PhonePlaceholder: "Zadejte telefonní číslo",
      Address: "Adresa",
      AddressPlaceholder: "Zadejte adresu",
      City: "Město",
      CityPlaceholder: "Zadejte město",
      PostalCode: "PSČ",
      PostalCodePlaceholder: "Zadejte PSČ (např. 123 45)",
      Country: "Země",
      CountryPlaceholder: "Vyberte zemi",
      Create: "Vytvořit",
      SuccessMessage: "Klient byl úspěšně vytvořen",
      ErrorMessage: "Nepodařilo se vytvořit klienta",
    },
    ClientDetail: {
      Information: "Informace",
      EditInformation: "Upravit informace",
      CompanyName: "Název společnosti",
      CompanyNumber: "IČO",
      TaxNumber: "DIČ",
      Email: "E-mail",
      Phone: "Telefon",
      Address: "Adresa",
      City: "Město",
      PostalCode: "PSČ",
      State: "Stát",
      Projects: "Projekty",
      NoProjects: "Žádné projekty",
      Contracts: "Smlouvy",
      NoContracts: "Žádné smlouvy",
      BackToClients: "Zpět na klienty",
      NotFound: "Klient nebyl nalezen",
      Activate: "Aktivovat",
      Deactivate: "Deaktivovat",
      ActivateSuccess: "Klient byl úspěšně aktivován",
      DeactivateSuccess: "Klient byl úspěšně deaktivován",
      StatusChangeError: "Nepodařilo se změnit stav klienta",
    },
    EditClientModal: {
      Title: "Upravit klienta",
      Save: "Uložit",
      SuccessMessage: "Klient byl úspěšně aktualizován",
      ErrorMessage: "Nepodařilo se aktualizovat klienta",
    },
  },
  Users: {
    Login: "Login",
    Name: "Jméno",
    FirstName: "Jméno",
    LastName: "Příjmení",
    SearchUsersPlaceholder: "Hledat uživatele...",
  },
  MusicAudio: {
    DisplayName: "Název",
    FileName: "Soubor",
    Duration: "Délka",
    DateCreated: "Datum vytvoření",
    SearchPlaceholder: "Hledat audio soubory...",
    UploadModal: {
      Title: "Nahrát audio soubor",
      DisplayName: "Název",
      DisplayNamePlaceholder: "Název souboru",
      SelectFile: "Vybrat soubor",
      Upload: "Nahrát",
      SuccessMessage: "Soubor byl úspěšně nahrán",
      ErrorMessage: "Nepodařilo se nahrát soubor",
      LicenseConfirmation:
        "Nahráním potvrzuji, že mám potřebná práva nebo licenci k použití tohoto audio souboru.",
    },
    DeleteDialog: {
      Title: "Smazat audio soubor",
      Content: "Opravdu chcete smazat tento audio soubor?",
      Confirm: "Smazat",
      SuccessMessage: "Soubor byl úspěšně smazán",
      ErrorMessage: "Nepodařilo se smazat soubor",
    },
    Download: "Stáhnout",
    DownloadError: "Nepodařilo se stáhnout soubor",
  },
  Billing: {
    CurrentBalance: "Aktuální zůstatek",
    TransactionHistory: "Historie transakcí",
    Date: "Datum",
    Type: "Typ",
    Description: "Popis",
    Amount: "Částka",
    BalanceAfter: "Zůstatek po",
    TransactionTypes: {
      Deposit: "Vklad",
      JobPayment: "Platba za job",
      Withdrawal: "Výběr",
      Reversal: "Storno",
      Adjustment: "Úprava",
    },
    DepositModal: {
      Title: "Vložit kredit",
      Amount: "Částka (EUR)",
      AmountPlaceholder: "Zadejte částku",
      Description: "Popis",
      DescriptionPlaceholder: "Volitelný popis vkladu",
      Confirm: "Přejít k platbě",
      SuccessMessage: "Přesměrování na platební bránu...",
      ErrorMessage: "Nepodařilo se zahájit platbu",
    },
    InitiateDeposit: "Vložit kredit",
    AvailableFunds: "Dostupné prostředky",
    Descriptions: {
      withdrawal: "Žádost o výběr #{{withdrawalRequestID}}",
      jobPayment: "Platba za job {{jobName}}, projekt {{projectName}}",
      reversal: "Stornovaná transakce: {{reason}}",
      reversalPayoutFailed: "Výplata selhala",
    },
  },
  Invoices: {
    Title: "Vyúčtování",
    InvoiceNumber: "Číslo faktury",
    IssueDate: "Datum vystavení",
    Type: "Typ",
    Seller: "Dodavatel",
    Buyer: "Odběratel",
    TotalAmount: "Celková částka",
    Status: "Stav",
    DownloadInvoice: "Stáhnout fakturu",
    DownloadError: "Nepodařilo se stáhnout fakturu",
    SearchPlaceholder: "Hledat faktury...",
    Types: {
      Standard: "Faktura",
      SelfBilling: "Samofaktura",
      CreditNote: "Dobropis",
    },
    Statuses: {
      Issued: "Vystavena",
      Paid: "Zaplacena",
      Cancelled: "Stornována",
    },
  },
  WithdrawalApprovals: {
    ActorName: "Herec",
    Amount: "Částka",
    Status: "Stav",
    RequestedAt: "Datum žádosti",
    IBAN: "IBAN",
    SWIFT: "SWIFT",
    ResolvedAt: "Datum vyřízení",
    ResolvedBy: "Vyřídil",
    ExpiresAt: "Platnost do",
    ActorBalance: "Zůstatek herce",
    EpcQrCode: "EPC QR kód pro platbu",
    CzechQrCode: "QR Platba (CZ)",
    SearchPlaceholder: "Hledat dle jména herce...",
    StatusPending: "Čeká na schválení",
    StatusApproved: "Schváleno",
    StatusRejected: "Zamítnuto",
    StatusExpired: "Vypršelo",
    Approve: "Schválit",
    Reject: "Zamítnout",
    RejectionReason: "Důvod zamítnutí",
    RejectionReasonPlaceholder: "Zadejte důvod zamítnutí...",
    ConfirmReject: "Potvrdit zamítnutí",
    ApproveSuccess: "Výplata byla úspěšně schválena",
    RejectSuccess: "Výplata byla zamítnuta",
    NotFound: "Žádost o výplatu nebyla nalezena",
  },
  Notifications: {
    Title: "Oznámení",
    Actions: "Akce",
    MarkAllAsRead: "Označit vše jako přečtené",
    DismissAll: "Zahodit vše",
    Empty: "Žádná oznámení",
    SysAdmin_ActorWithdrawalRequested:
      "Herec {{actorName}} požádal o výplatu {{amount}} EUR.",
    SysAdmin_PartnerRegistrationRequested:
      "Nová žádost o registraci partnera od {{contactName}} ({{companyName}}).",
    SysAdmin_ActorRegistrationRequested:
      "Nová žádost o registraci herce od {{actorName}} ({{email}}).",
    Partner_JobApprovedByActor:
      "Herec {{actorName}} schválil úlohu {{jobName}} v projektu {{projectName}}.",
    Partner_JobRejectedByActor:
      "Herec {{actorName}} zamítl úlohu {{jobName}} v projektu {{projectName}}.",
    RelativeTime: {
      JustNow: "Právě teď",
      MinutesAgo: "před {{count}} min",
      HoursAgo: "před {{count}} h",
      DaysAgo: "před {{count}} d",
    },
  },
  RegistrationRequests: {
    Name: "Jméno",
    Type: "Typ",
    Status: "Stav",
    Email: "E-mail",
    Phone: "Telefon",
    Company: "Společnost",
    DateCreated: "Datum vytvoření",
    SearchPlaceholder: "Hledat žádosti...",
    StatusPending: "Čeká na vyřízení",
    StatusResolved: "Vyřízeno",
    StatusApproved: "Schváleno",
    StatusRejected: "Zamítnuto",
    TypePartner: "Partner",
    TypeActor: "Herec",
    AllStatuses: "Všechny stavy",
    AllTypes: "Všechny typy",
    Resolve: "Vyřídit",
    ResolveSuccess: "Žádost byla úspěšně vyřízena.",
    NotFound: "Žádost o registraci nebyla nalezena.",
    CreatePartner: "Vytvořit partnera",
    DetailTitle: "Detail žádosti o registraci",
    FirstName: "Jméno",
    LastName: "Příjmení",
  },
  Reporting: {
    Title: "Reporting",
    RevenueThisMonth: "Obrat tento měsíc",
    ActiveProjects: "Aktivní projekty",
    NewPartnersThisMonth: "Noví partneři tento měsíc",
    JobsThisMonth: "Joby tento měsíc",
    RevenueOverTime: "Obrat v čase",
    ProjectStatusDistribution: "Stav projektů",
    AverageCompletionTime: "Průměrná doba dokončení",
    AverageJobCost: "Průměrná cena jobu",
    AverageActorApprovalTime: "Průměrná doba schválení hercem",
    Days: "dní",
    TopActorsByJobs: "Top herci dle jobů",
    TopActorsByEarnings: "Nejvýdělečnější herci",
    TopPartnersByProjects: "Partneři s nejvíce projekty",
    TopPartnersByJobs: "Partneři s nejvíce joby",
    TopPartnersBySpend: "Partneři s nejvíce útratou",
    AvgGenerationsPerJob: "Průměrný počet generování na job",
    VoiceModelUsageThisMonth: "Nejpoužívanější AI modely tento měsíc",
    JobStatusDistribution: "Stav jobů",
    NoData: "Nejsou k dispozici žádná data",
    Revenue: "Obrat",
    Jobs: "Joby",
    Earnings: "Výdělky",
    PeriodAll: "Celé období",
    PeriodThisMonth: "Tento měsíc",
    PeriodLast30Days: "Posledních 30 dní",
    PeriodThisYear: "Tento rok",
    PeriodLastYear: "Poslední rok",
  },
  Errors: {
    ApplicationError: {
      Title: "Nastala chyba",
      Subtitle: "Je nám líto, v aplikaci došlo k chybě.",
      Description:
        "Naši programátoři již o chybě byli informováni a na opravě už pracují.",
      DebugHint: "Jste programátor? Koukněte v čem byla chyba.",
      Home: "Domů",
    },
    Error404: {
      Subtitle: "Stránka nebyla nalezena",
      Home: "Domů",
    },
    Error403: {
      Subtitle: "K zobrazení této stránky nemáte přístupová práva",
    },
    Error500: "Při zpracování požadavku nastala chyba.",
    UserNotFound: "Uživatel nenalezen",
    PartnerNotFound: "Partner nebyl nalezen",
  },
  SignIn: {
    Error: {
      General: "Nastala chyba",
      AccountIsDisabled: "Účet je zablokován",
      InvalidCredentials: "Neplatné přihlašovací údaje",
      AccountWaitingForEmailConfirmation: "Účet čeká na potvrzení e-mailu",
      ApplicationVerification: "Neplatné přihlašovací údaje",
      InvalidToken: "Neplatný token",
      PhoneNumberNotFound: "Telefonní číslo nebylo nalezeno",
      SmsSendingFailed: "Odeslání SMS se nezdařilo",
      InsufficientRole: "Uživatel s touto rolí nemá oprávnění",
      AccountWaitingForSetPassword: "Účet čeká na nastavení hesla",
    },
    Title: "Přihlášení",
    Subtitle:
      "Vítejte zpět! Zadejte přihlašovací údaje a pokračujte ve své práci.",
    Username: {
      Label: "Uživatelské jméno",
    },
    Password: {
      Label: "Heslo",
    },
    DoNotHaveAccount: "Nemáte účet?",
    ForgottenPassword: "Zapomenuté heslo?",
    RegisterNow: "Registrovat nyní",
    Cookies: "Cookies",
    Help: "Pomoc",
    Button: "Přihlásit",
  },
  SignUp: {
    Title: "Registrace partnera",
    Subtitle:
      "Vyplňte registrační formulář a brzy vás zkontaktujeme s přístupem do systému.",
    FirstName: { Label: "Jméno" },
    LastName: { Label: "Příjmení" },
    Company: { Label: "Firma" },
    Email: { Label: "E-mail" },
    Phone: { Label: "Telefon" },
    TermsAndConditions: "Vytvořením účtu souhlasíte s AI Connect",
    TermsLink: "obchodními podmínkami",
    Button: "Registrovat",
    AlreadyHaveAccount: "Již máte účet?",
    SignInNow: "Přihlásit se",
    RegistrationNote:
      "Registrace herců probíhá prostřednictvím nahrávacích sessí, pro více informací kontaktujte náš",
    ProductionTeam: "produkční tým",
    Success: {
      Title: "Žádost odeslána",
      Description:
        "Vaše žádost o registraci byla úspěšně odeslána. Budeme vás kontaktovat na zadaný e-mail.",
    },
    Error: {
      General: "Nastala chyba",
      UserExists: "Účet s tímto e-mailem již existuje",
      DuplicateRequest:
        "Žádost o registraci s tímto e-mailem již byla odeslána",
      WeakPassword:
        "Heslo musí mít alespoň 8 znaků, obsahovat jedno malé, jedno velké písmeno a jedno číslo",
    },
  },
  RegisterActor: {
    Title: "Registrace herce",
    Subtitle:
      "Vyplňte registrační formulář a brzy vás zkontaktujeme s přístupem do systému.",
    FirstName: { Label: "Jméno" },
    LastName: { Label: "Příjmení" },
    Company: { Label: "Firma (volitelné)" },
    Email: { Label: "E-mail" },
    Phone: { Label: "Telefon" },
    TermsAndConditions: "Vytvořením účtu souhlasíte s AI Connect",
    TermsLink: "obchodními podmínkami",
    Button: "Registrovat",
    AlreadyHaveAccount: "Již máte účet?",
    SignInNow: "Přihlásit se",
    Success: {
      Title: "Žádost odeslána",
      Description:
        "Vaše žádost o registraci byla úspěšně odeslána. Budeme vás kontaktovat na zadaný e-mail.",
    },
    Error: {
      General: "Nastala chyba",
      UserExists: "Účet s tímto e-mailem již existuje",
      DuplicateRequest:
        "Žádost o registraci s tímto e-mailem již byla odeslána",
    },
  },
  Legal: {
    Body: "Tento dokument se právě připravuje a bude brzy doplněn. Děkujeme za trpělivost. Máte-li dotazy ohledně zpracování osobních údajů nebo podmínek používání, kontaktujte nás prosím.",
    PrivacyPolicy: {
      Title: "Zásady ochrany osobních údajů",
    },
    TermsOfService: {
      Title: "Podmínky používání",
    },
  },
  Support: {
    Title: "Podpora a nápověda",
    Body: "Stránka podpory se právě připravuje a bude brzy doplněna. Potřebujete-li pomoc, kontaktujte nás prosím e-mailem a rádi vám pomůžeme.",
  },
  Validation: {
    Required: "Vyplňte pole",
    InvalidEmail: "E-mail je nevalidní",
    AlphabetsOnly: "Pro toto pole jsou povoleny pouze písmenka",
    DigitsOnly: "Může obsahovat pouze číslice",
    InvalidPhone: "Telefonní číslo je nevalidní",
    InvalidFormat: "Neplatný formát",
    InvalidBankAccount: "Neplatné číslo účtu",
    InvalidPersonalIdentificationNumber: "Neplatné rodné číslo",
    InvalidTaxNumber: "Neplatné DIČ",
    InvalidCompanyNumber: "Neplatné IČO",
    InvalidPostalCode: "Neplatný formát PSČ",
    IsTrue: "Musí být zaškrtnuto",
    Number: {
      Integer: "Musí být celé číslo",
      Min: "Hodnota musí být nezáporná",
      MoreThen: "Musí být větší než 0",
    },
    String: {
      Min: "Musí být alespoň {{count}} znaků dlouhé.",
      Max: "Nesmí být delší než {{count}} znaků.",
      StrictLength: "Musí obsahovat {{count}} znaků",
      InvalidFormat: "Neplatný formát",
    },
    Array: {
      Min: "Vyberte alespoň jednu položku.",
      Min_one: "Musí být vybrána alespoň {{count}} položka.",
      Min_few: "Musí být vybrány alespoň {{count}} položky.",
      Min_other: "Musí být vybráno alespoň {{count}} položek.",
    },
    Date: {
      MustBeAfterStartDate: "Datum ukončení musí být po datu zahájení",
    },
  },
  SetPassword: {
    Title: "Nastavení hesla",
    Subtitle:
      "Pro aktivaci účtu nebo změnu hesla si nastavte nové, bezpečné heslo.",
    Password: { Label: "Heslo" },
    ConfirmPassword: { Label: "Potvrdit heslo" },
    Button: "Nastavit heslo",
    PasswordsMustMatch: "Hesla se musí shodovat",
    SuccessMessage: "Heslo bylo úspěšně nastaveno. Nyní se můžete přihlásit.",
    Error: {
      General:
        "Odkaz pro nastavení hesla je neplatný nebo vypršel. Požádejte o nový odkaz.",
      TokenNotFound: "Neplatný odkaz",
      WeakPassword:
        "Heslo musí mít alespoň 8 znaků, obsahovat jedno malé, jedno velké písmeno a jedno číslo",
    },
  },
  ResetPassword: {
    Title: "Obnovení hesla",
    Subtitle: "Zadejte svůj e-mail a my vám pošleme odkaz pro obnovení hesla.",
    Email: { Label: "E-mail" },
    Button: "Odeslat odkaz",
    BackToSignIn: "Zpět na přihlášení",
    Success: {
      Title: "Zkontrolujte svůj e-mail",
      Description:
        "Pokud e-mail existuje v našem systému, byl na něj odeslán odkaz pro obnovení hesla.",
    },
  },
  BlDatePicker: {
    Locales: {
      One: "den",
      Two: "dny",
      Few: "dny",
      Other: "dnů",
      Many: "dnů",
      Zero: "dnů",
    },
    Placeholder: "Vyberte datum",
    Presets: {
      Today: "Dnes",
      Yesterday: "Včera",
      Last7Days: "Posledních 7 dní",
      Last30Days: "Posledních 30 dní",
      ThisMonth: "Tento měsíc",
      LastMonth: "Minulý měsíc",
    },
  },
  Autocomplete: {
    ClearText: "Smazat",
    CloseText: "Zavřít",
    OpenText: "Otevřít",
    NoOptionsText: "Žádné možnosti",
    LoadingText: "Načítání...",
  },
  TextEditor: {
    Bold: "Tučné",
    Italic: "Kurzíva",
    Underline: "Podtržení",
    Strikethrough: "Přeškrtnutí",
    Code: "Kód",
    Paragraph: "Odstavec",
    Heading1: "Nadpis 1",
    Heading2: "Nadpis 2",
    Heading3: "Nadpis 3",
    BulletList: "Odrážkový seznam",
    OrderedList: "Číslovaný seznam",
    Blockquote: "Citace",
    CodeBlock: "Blok kódu",
    HorizontalRule: "Vodorovná čára",
    Superscript: "Horní index",
    Subscript: "Dolní index",
    AlignLeft: "Zarovnat vlevo",
    AlignCenter: "Zarovnat na střed",
    AlignRight: "Zarovnat vpravo",
    AlignJustify: "Zarovnat do bloku",
    Highlight: "Zvýraznění",
  },
  Table: {
    NoData: "Žádná data",
    NextPage: "Další strana",
    PrevPage: "Předchozí strana",
    RowsPerPage: "Řádků na stránku",
  },
  Documents: {
    SectionTitle: "Dokumenty",
    UploadButton: "Nahrát dokument",
    ChooseFile: "Vybrat soubor",
    DisplayNameLabel: "Název dokumentu",
    UploadModalTitle: "Nahrát dokument",
    NoDocuments: "Žádné dokumenty",
    DownloadError: "Nepodařilo se stáhnout dokument",
    DeleteError: "Nepodařilo se smazat dokument",
    UploadError: "Nepodařilo se nahrát dokument",
  },
  ApiErrors: {
    General: "Nastala neočekávaná chyba. Zkuste to prosím znovu.",
    SearchExternalVoices: {
      General: "Nepodařilo se vyhledat hlasy.",
      UnsupportedVoiceLlm: "Vybraný hlasový model není podporován.",
    },
    UploadUserProfilePicture: {
      General: "Nepodařilo se nahrát profilovou fotografii.",
      UserNotFound: "Uživatel nebyl nalezen.",
      FileTooLarge: "Soubor je příliš velký.",
      InvalidFileType: "Nepodporovaný formát souboru.",
    },
    DeleteUserProfilePicture: {
      General: "Nepodařilo se smazat profilovou fotografii.",
      UserNotFound: "Uživatel nebyl nalezen.",
    },
    DocumentUpload: {
      General: "Nepodařilo se nahrát dokument.",
      EntityNotFound: "Entita nebyla nalezena.",
      FileTooLarge: "Soubor je příliš velký.",
      InvalidFileType: "Nepodporovaný formát souboru.",
    },
    SaveProject: {
      General: "Nepodařilo se uložit projekt.",
      ClientNotFound: "Klient nebyl nalezen.",
      ClientInactive: "Klient je deaktivovaný.",
      ModuleNotFound: "Modul nebyl nalezen.",
      CurrentUserNotConnectWithPartner:
        "Váš účet není propojen s žádným partnerem.",
      ProjectNotFound: "Projekt nebyl nalezen.",
      DuplicateExclusiveContractActor:
        "Stejný herec nemůže mít více exkluzivních smluv v jednom projektu.",
      ExclusiveContractActorNotFound:
        "Herec pro exkluzivní smlouvu nebyl nalezen.",
      ExclusiveContractActorIndustryNotAllowed:
        "Herec pro exkluzivní smlouvu nemá povoleno odvětví projektu.",
    },
    SyncProjectActors: {
      General: "Nepodařilo se synchronizovat herce projektu.",
      ProjectNotFound: "Projekt nebyl nalezen.",
      ActorsNotFound: "Herec nebo herci nebyli nalezeni.",
      ActorPriceCategoryNotAllowed: "Cenová kategorie herce není povolena.",
      ActorNotOpenToCollaboration: "Herec není otevřen spolupráci.",
      TooManyActorsForSingleVoiceSpot:
        "Příliš mnoho herců pro jedno hlasové místo.",
      CannotChangeActorWithCompletedJobs:
        "Nelze změnit herce u dokončených jobů.",
      ActorIndustryNotAllowed: "Herec nemá povoleno toto odvětví.",
      CannotRemoveActorWithActiveJobs:
        "Herce nelze odebrat, protože má dokončené nebo čekající joby.",
    },
    SavePriceCategory: {
      General: "Nepodařilo se uložit cenovou kategorii.",
      PriceCategoryNotFound: "Cenová kategorie nebyla nalezena.",
      NameAlreadyExists: "Cenová kategorie s tímto názvem již existuje.",
      CommissionRateOutOfRange: "Provizní sazba je mimo povolený rozsah.",
    },
    CreatePartnerMediaFile: {
      General: "Nepodařilo se nahrát mediální soubor.",
      FileTooLarge: "Soubor je příliš velký.",
      InvalidFileType: "Nepodporovaný formát souboru.",
      PartnerNotFound: "Partner nebyl nalezen.",
      LicenseNotConfirmed:
        "Pro nahrání musíte potvrdit, že máte licenci k audio souboru.",
    },
    TogglePartnerModule: {
      General: "Nepodařilo se změnit stav modulu.",
      PartnerNotFound: "Partner nebyl nalezen.",
      ModuleNotFound: "Modul nebyl nalezen.",
      AlreadyEnabled: "Modul je již aktivní.",
      AlreadyDisabled: "Modul je již neaktivní.",
    },
    SetPartnerModules: {
      General: "Nepodařilo se uložit moduly partnera.",
      PartnerNotFound: "Partner nebyl nalezen.",
      ModuleNotFound: "Modul nebyl nalezen.",
    },
    SetModulePartners: {
      General: "Nepodařilo se uložit partnery modulu.",
      ModuleNotFound: "Modul nebyl nalezen.",
      PartnerNotFound: "Partner nebyl nalezen.",
    },
    SavePartner: {
      General: "Nepodařilo se uložit partnera.",
      ParentPartnerNotFound: "Nadřazený partner nebyl nalezen.",
      HierarchyTooDeep: "Hierarchie partnerů je příliš hluboká.",
      CannotSetParentWithChildren:
        "Nelze nastavit nadřazeného partnera, pokud má partner podřízené.",
      CannotBeSelfParent: "Partner nemůže být svým vlastním nadřazeným.",
      UserWithLoginAlreadyExists: "Uživatel s tímto e-mailem již existuje.",
    },
    SaveModule: {
      General: "Nepodařilo se uložit modul.",
      PriceCategoryNotFound: "Cenová kategorie nebyla nalezena.",
    },
    SaveModuleQuestions: {
      General: "Nepodařilo se uložit otázky modulu.",
      ModuleNotFound: "Modul nebyl nalezen.",
      InvalidQuestionConfiguration: "Neplatná konfigurace otázky.",
    },
    SaveJobAnswers: {
      General: "Nepodařilo se uložit odpovědi.",
      JobNotFound: "Job nebyl nalezen.",
      MissingRequiredAnswer: "Chybí odpověď na povinnou otázku.",
      InvalidOption: "Neplatná vybraná možnost.",
      InvalidQuestion: "Neplatná otázka.",
      TooManyOptionsForSingleChoice:
        "U otázky s jednou volbou lze vybrat pouze jednu možnost.",
    },
    CreateJob: {
      General: "Nepodařilo se vytvořit job.",
      ProjectNotFound: "Projekt nebyl nalezen.",
      JobsLimitExceeded: "Byl překročen limit počtu jobů v projektu.",
    },
    SaveJobScript: {
      General: "Nepodařilo se uložit scénář.",
      JobNotFound: "Job nebyl nalezen.",
    },
    GenerateVoicelines: {
      General: "Nepodařilo se vygenerovat hlasové linky.",
      ProjectNotFound: "Projekt nebyl nalezen.",
      JobNotFound: "Job nebyl nalezen.",
      UnsupportedTextLlm: "Vybraný textový model není podporován.",
      GenerationFailed: "Generování se nezdařilo. Zkuste to prosím znovu.",
      RateLimited:
        "Služba generování textu je dočasně přetížená nebo byl vyčerpán limit požadavků. Zkuste to prosím za chvíli.",
    },
    GenerateJobClip: {
      General: "Nepodařilo se vygenerovat spot.",
      JobNotFound: "Job nebyl nalezen.",
      ScriptNotFound: "Scénář nebyl nalezen.",
      GenerationFailed: "Generování se nezdařilo. Zkuste to prosím znovu.",
      ExclusiveContractJobLimitReached:
        "Byl dosažen limit zakázek exkluzivní smlouvy pro tohoto herce.",
    },
    RetryFinalization: {
      General: "Nepodařilo se znovu finalizovat job.",
      JobNotFound: "Job nebyl nalezen.",
      InvalidJobStatus: "Job není ve správném stavu pro tuto akci.",
      NotAllApproved: "Ne všechny hlasové linky jsou schváleny.",
      InsufficientBalance: "Na účtu není dostatek kreditu.",
      FinalizationFailed: "Finalizace se nezdařila. Zkuste to prosím znovu.",
    },
    SubmitJob: {
      General: "Nepodařilo se odeslat job.",
      JobNotFound: "Job nebyl nalezen.",
      ClipNotFound: "Spot nebyl nalezen.",
      ClipNotFullType: "Spot není plného typu.",
      JobNotSubmittable: "Job není ve stavu, který umožňuje odeslání.",
      InsufficientBalance: "Na účtu není dostatek kreditu.",
      FinalizationFailed: "Finalizace se nezdařila. Zkuste to prosím znovu.",
    },
    GetFileDownloadUrl: {
      General: "Nepodařilo se stáhnout soubor.",
      FileNotFound: "Soubor nebyl nalezen.",
    },
    SaveClient: {
      General: "Nepodařilo se uložit klienta.",
      CompanyNumberAlreadyExists: "Klient s tímto IČO již existuje.",
      UnauthorizedAccess: "Nemáte oprávnění k této operaci.",
      PartnerRequired: "Pro tuto akci je vyžadován partner.",
    },
    InitiateDeposit: {
      General: "Nepodařilo se zahájit platbu.",
      PartnerRequired: "Pro vklad je vyžadován partner.",
      IdempotencyKeyRequired: "Chybí identifikátor transakce.",
      InvalidAmount: "Zadaná částka je neplatná.",
    },
    RegisterPartner: {
      General: "Registrace se nezdařila.",
      UserExists: "Účet s tímto e-mailem již existuje.",
      DuplicateRequest:
        "Žádost o registraci s tímto e-mailem již byla odeslána.",
    },
    RegisterActor: {
      General: "Registrace herce se nezdařila.",
      UserExists: "Účet s tímto e-mailem již existuje.",
      DuplicateRequest:
        "Žádost o registraci s tímto e-mailem již byla odeslána.",
    },
    DetectAudioWatermark: {
      General: "Nepodařilo se detekovat vodoznak.",
      InvalidFileType: "Nepodporovaný formát souboru.",
      UnsupportedAudioFormat: "Nepodporovaný formát audia.",
    },
    SaveActorPriceCategories: {
      General: "Nepodařilo se uložit cenové kategorie herce.",
      PriceCategoryNotFound: "Cenová kategorie nebyla nalezena.",
    },
    SaveActor: {
      General: "Nepodařilo se uložit herce.",
      EmailAlreadyExists: "Herec s tímto e-mailem již existuje.",
      ActorAlreadyExists: "Herec již existuje.",
      PartnerRequired: "Pro tuto akci je vyžadován partner.",
    },
    SaveActorVoice: {
      General: "Nepodařilo se uložit hlas herce.",
      ActorNotFound: "Herec nebyl nalezen.",
      ExternalVoiceIDEmpty: "ID externího hlasu nesmí být prázdné.",
      ActorVoiceNotFound: "Hlas herce nebyl nalezen.",
      TrainingTypeNotSupportedForVoiceLlm:
        "Tento typ tréninku není podporován vybraným modelem.",
      CannotChangeVoiceConfigAfterDraft:
        "Konfiguraci hlasu nelze změnit po opuštění stavu konceptu.",
    },
    UploadActorVoiceTrainingFile: {
      General: "Nepodařilo se nahrát trénovací soubor.",
      FileTooLarge: "Soubor je příliš velký.",
      InvalidFileType: "Nepodporovaný formát souboru.",
      ActorVoiceNotFound: "Hlas herce nebyl nalezen.",
      MaxFilesExceeded: "Byl překročen maximální počet trénovacích souborů.",
      ThisVoiceModelCannotBeTrained: "Tento hlasový model nelze trénovat.",
      DuplicateFile: "Tento soubor již byl nahrán.",
      CaptchaFileAlreadyExists: "Captcha soubor již existuje.",
      CaptchaFileNotAllowedForInstant:
        "Captcha soubor není povolen pro instant trénink.",
    },
    DeleteActorVoiceTrainingFile: {
      General: "Nepodařilo se smazat trénovací soubor.",
      TrainingFileNotFound: "Trénovací soubor nebyl nalezen.",
      WrongStatus: "Hlas herce není ve správném stavu pro tuto akci.",
    },
    DeleteAllActorVoiceTrainingFiles: {
      General: "Nepodařilo se smazat trénovací soubory.",
      ActorVoiceNotFound: "Hlas herce nebyl nalezen.",
      WrongStatus: "Hlas herce není ve správném stavu pro tuto akci.",
    },
    GenerateActorVoicePreview: {
      General: "Nepodařilo se vygenerovat ukázku hlasu.",
      ActorVoiceNotFound: "Hlas herce nebyl nalezen.",
      WrongStatus: "Hlas herce není ve správném stavu pro tuto akci.",
      InvalidParameters: "Neplatné parametry pro generování ukázky.",
      GenerationFailed:
        "Generování ukázky se nezdařilo. Zkuste to prosím znovu.",
    },
    TrainingActorVoice: {
      General: "Nepodařilo se zahájit trénink hlasu.",
      LlmModelNotSupportCustomTraining:
        "Vybraný model nepodporuje vlastní trénink.",
      TrainingFilesEmpty: "Nejsou nahrány žádné trénovací soubory.",
      ActorVoiceNotFound: "Hlas herce nebyl nalezen.",
      WrongStatus: "Hlas herce není ve správném stavu pro tuto akci.",
      CaptchaFileRequired: "Je vyžadován captcha soubor.",
      InsufficientAudioDuration: "Celková délka nahrávek je příliš krátká.",
    },
    ApproveWithdrawal: {
      General: "Nepodařilo se schválit výplatu.",
      NotFound: "Žádost o výplatu nebyla nalezena.",
      AlreadyProcessed: "Tato žádost již byla zpracována.",
      Expired: "Platnost žádosti vypršela.",
      LedgerError: "Chyba při zpracování platby.",
    },
    RejectWithdrawal: {
      General: "Nepodařilo se zamítnout výplatu.",
      NotFound: "Žádost o výplatu nebyla nalezena.",
      AlreadyProcessed: "Tato žádost již byla zpracována.",
    },
    ResolveRegistrationRequest: {
      General: "Nepodařilo se vyřídit žádost o registraci.",
      NotFound: "Žádost o registraci nebyla nalezena.",
      AlreadyResolved: "Tato žádost již byla vyřízena.",
    },
  },
};
